module.exports = __webpack_public_path__ + "static/media/follow-astro.0436bc6b.png";